import { InputGroup } from "../../InputGroup-DzAlYrM8.js";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/blocks/NumberInput/NumberInput.tsx
const toNumberOrNull = (event) => Number.isNaN(event.target.valueAsNumber) ? null : event.target.valueAsNumber;
const NumberInput = ({ ref, state, variant, focusVariant, sizing, className, value, defaultValue, onValueChange, onValueBlur, onChange, onBlur, prefix, suffix, ...inputProps }) => {
	const handleChange = (event) => {
		onValueChange?.(toNumberOrNull(event));
		onChange?.(event);
	};
	const handleBlur = (event) => {
		onValueBlur?.(toNumberOrNull(event));
		onBlur?.(event);
	};
	const valueProp = value !== void 0 ? { value: value ?? "" } : { defaultValue: defaultValue ?? "" };
	return /* @__PURE__ */ jsxs(InputGroup, {
		state,
		variant,
		sizing,
		focusVariant,
		className,
		children: [
			prefix && /* @__PURE__ */ jsx(InputGroup.Addon, {
				align: "inline-start",
				children: prefix
			}),
			/* @__PURE__ */ jsx(InputGroup.Input, {
				...inputProps,
				...valueProp,
				ref,
				type: "number",
				onChange: handleChange,
				onBlur: handleBlur
			}),
			suffix && /* @__PURE__ */ jsx(InputGroup.Addon, {
				align: "inline-end",
				children: suffix
			})
		]
	});
};
//#endregion
export { NumberInput };

//# sourceMappingURL=NumberInput.js.map